import { createContext, type ReactNode, useContext } from 'react'
import { createPortal } from 'react-dom'

type PlanSectionHeaderSlot = {
  /** The element in the window's header the section's own controls are drawn into. */
  slot: HTMLElement | null
}

export const PlanSectionHeaderSlotContext = createContext<PlanSectionHeaderSlot | null>(null)

/** Whether the section is drawn in the plan-section window, where it may put controls in the
 *  window's header instead of its own. */
export const useIsInPlanSectionDialog = () => useContext(PlanSectionHeaderSlotContext) !== null

/**
 * Draws a section's own controls in the window's header, before the window's own actions, so they
 * stand on the header's right edge as every card header's actions do. Outside the window it draws
 * nothing: the section keeps its own controls there.
 */
export const PlanSectionHeaderActions = ({ children }: { children: ReactNode }) => {
  const context = useContext(PlanSectionHeaderSlotContext)

  return context?.slot ? createPortal(children, context.slot) : null
}
